import { FC, useMemo } from 'react';
import { Empty } from 'antd';
import { useTranslate } from '@refinedev/core';
import { DataTable } from '../../../data-table';

interface ChangesProps {
    data: any[];
    group: string;
}

export const Changes: FC<ChangesProps> = ({ data, group }) => {
    const t = useTranslate();

    const normalizedData = useMemo(
        () => (Array.isArray(data) ? data : []),
        [data]
    );

    if (normalizedData.length === 0) {
        return <Empty description={t('applications.titles.no_data')} />;
    }

    return (
        <DataTable
            data={normalizedData}
            group="applications.titles"
            pageSizeSelectorWidth={96}
        />
    );
};
